export default __webpack_public_path__ + "ca1fdd5fe6ef6c746667abf278131681.png";